document.documentElement.classList.remove('no-js');

const sahrava = {
  root: window.Shopify?.routes?.root || '/',
  toastTimer: null,
  showToast(message) {
    const toast = document.querySelector('.site-toast');
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    window.clearTimeout(this.toastTimer);
    this.toastTimer = window.setTimeout(() => { toast.hidden = true; }, 2800);
  },
  lockPage(locked) {
    document.documentElement.classList.toggle('is-locked', locked);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-site-header]');
  const updateHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 12);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  document.querySelectorAll('[data-language-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.requestSubmit());
  });
  document.querySelectorAll('[data-auto-submit]').forEach((select) => {
    select.addEventListener('change', () => {
      if (select.name === 'sort_by') {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
        return;
      }
      select.form?.submit();
    });
  });

  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filterPanel = document.querySelector('[data-filter-panel]');
  const filterClose = document.querySelector('[data-filter-close]');
  const collectionLayout = document.querySelector('[data-collection-layout]');
  const filterMobileMedia = window.matchMedia('(max-width: 899px)');
  const syncFilterPanelMode = () => {
    if (!filterPanel) return;
    if (filterMobileMedia.matches) {
      // Keep the mobile dialog above the catalogue and header stacking contexts.
      if (filterPanel.parentElement !== document.body) document.body.append(filterPanel);
      filterPanel.setAttribute('role', 'dialog');
      filterPanel.setAttribute('aria-modal', 'true');
      document.body.classList.toggle('filters-panel-open', !filterPanel.hidden);
    } else {
      if (collectionLayout && filterPanel.parentElement !== collectionLayout) collectionLayout.prepend(filterPanel);
      filterPanel.removeAttribute('role');
      filterPanel.removeAttribute('aria-modal');
      document.body.classList.remove('filters-panel-open');
    }
  };
  const setFiltersOpen = (open, restoreFocus = false) => {
    if (!filterPanel) return;
    syncFilterPanelMode();
    filterPanel.hidden = !open;
    filterToggle?.setAttribute('aria-expanded', String(open));
    collectionLayout?.classList.toggle('filters-open', open);
    document.body.classList.toggle('filters-panel-open', open && filterMobileMedia.matches);
    if (open) filterClose?.focus();
    if (!open && restoreFocus) filterToggle?.focus();
  };
  syncFilterPanelMode();
  filterMobileMedia.addEventListener('change', syncFilterPanelMode);
  filterToggle?.addEventListener('click', () => {
    if (!filterPanel) return;
    setFiltersOpen(filterPanel.hidden);
  });
  filterClose?.addEventListener('click', () => setFiltersOpen(false, true));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && filterPanel && !filterPanel.hidden) setFiltersOpen(false, true);
    if (event.key !== 'Tab' || !filterMobileMedia.matches || !filterPanel || filterPanel.hidden) return;
    const focusable = [...filterPanel.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), summary')];
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.querySelectorAll('[data-quantity-control]').forEach((control) => {
    const input = control.querySelector('input[type="number"]');
    if (!input) return;
    const normalizeQuantity = (value) => {
      const minimum = Number(input.min || 0);
      const maximum = input.max === '' ? Infinity : Number(input.max);
      const parsed = Number(value);
      return Math.min(maximum, Math.max(minimum, Number.isFinite(parsed) ? Math.floor(parsed) : minimum));
    };
    const setQuantity = (value) => {
      input.value = String(normalizeQuantity(value));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    control.querySelector('[data-quantity-minus]')?.addEventListener('click', () => setQuantity(Number(input.value || input.min || 0) - 1));
    control.querySelector('[data-quantity-plus]')?.addEventListener('click', () => setQuantity(Number(input.value || input.min || 0) + 1));
    input.addEventListener('change', () => { input.value = String(normalizeQuantity(input.value)); });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const root = select.closest('[data-product-root]');
      const price = root?.querySelector('[data-product-price] .price');
      const button = root?.querySelector('[data-add-to-cart]');
      const available = option.dataset.available === 'true';
      const currentPrice = price?.querySelector('[data-price-current]');
      const comparePrice = price?.querySelector('[data-price-compare]');
      if (currentPrice && option.dataset.price) currentPrice.textContent = option.dataset.price;
      const onSale = option.dataset.onSale === 'true';
      price?.classList.toggle('price--sale', onSale);
      if (comparePrice) {
        comparePrice.hidden = !onSale;
        comparePrice.textContent = option.dataset.comparePrice || '';
      }
      if (button) {
        button.disabled = !available;
        button.dataset.variantAvailable = String(available);
        button.textContent = available ? button.dataset.availableLabel || 'Add to bag' : button.dataset.soldOutLabel || 'Sold out';
      }
      const stock = root?.querySelector('[data-product-stock]');
      if (stock) {
        stock.classList.toggle('is-sold-out', !available);
        stock.textContent = available ? stock.dataset.availableLabel : stock.dataset.soldOutLabel;
      }
      const quantityRow = root?.querySelector('[data-product-quantity]');
      if (quantityRow) {
        quantityRow.hidden = !available;
        const quantity = quantityRow.querySelector('input[name="quantity"]');
        if (quantity) {
          quantity.disabled = !available;
          quantity.max = option.dataset.maxQuantity || '';
          quantity.value = '1';
        }
      }
      const wishlistProduct = root?.querySelector('.product-wishlist[data-wishlist-product]');
      if (wishlistProduct && option.dataset.price) wishlistProduct.dataset.price = option.dataset.price;
    });
  });

  document.querySelectorAll('[data-media-target]').forEach((button) => {
    button.addEventListener('click', () => {
      const gallery = button.closest('[data-product-gallery]');
      gallery?.querySelectorAll('[data-media-id]').forEach((item) => item.classList.toggle('is-active', item.dataset.mediaId === button.dataset.mediaTarget));
      gallery?.querySelectorAll('[data-media-target]').forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb === button);
        if (thumb.hasAttribute('aria-pressed')) thumb.setAttribute('aria-pressed', String(thumb === button));
      });
    });
  });

  document.querySelectorAll('form[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      if (button?.disabled || form.dataset.submitting === 'true' || !form.reportValidity()) return;
      const isArabic = document.documentElement.lang === 'ar';
      form.dataset.submitting = 'true';
      button?.setAttribute('aria-busy', 'true');
      if (button) button.disabled = true;
      try {
        const response = await fetch(`${sahrava.root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        await response.json();
        if (!response.ok) {
          const message = response.status === 422
            ? (isArabic ? 'الكمية المطلوبة غير متاحة. راجع الكمية في الحقيبة.' : 'The requested quantity is unavailable. Check the quantity in your bag.')
            : (isArabic ? 'تعذرت الإضافة. يرجى المحاولة مجددًا.' : 'Unable to add this item. Please try again.');
          sahrava.showToast(message);
          return;
        }
        const cartResponse = await fetch(`${sahrava.root}cart.js`, { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) {
          window.location.assign(`${sahrava.root}cart`);
          return;
        }
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; count.hidden = cart.item_count === 0; });
        sahrava.showToast(isArabic ? 'تمت الإضافة إلى الحقيبة' : 'Added to your bag');
        document.dispatchEvent(new CustomEvent('sahrava:cart-added', { detail: { cart } }));
      } catch {
        sahrava.showToast(isArabic ? 'تعذر تأكيد الإضافة. راجع الحقيبة قبل المحاولة مرة أخرى.' : 'We could not confirm the update. Check your bag before trying again.');
      } finally {
        delete form.dataset.submitting;
        button?.removeAttribute('aria-busy');
        if (button) button.disabled = button.dataset.variantAvailable === 'false';
      }
    });
  });

  const wishlistKey = 'sahrava:wishlist';
  const readWishlist = () => {
    try {
      const value = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
      return Array.isArray(value) ? value.filter((item) => item && typeof item.handle === 'string') : [];
    } catch {
      return [];
    }
  };
  const writeWishlist = (items) => {
    try {
      localStorage.setItem(wishlistKey, JSON.stringify(items.slice(0, 100)));
      return true;
    } catch {
      sahrava.showToast(document.documentElement.lang === 'ar' ? 'تعذر حفظ المفضلة في هذا المتصفح. يرجى المحاولة مجددًا.' : 'Unable to save your wishlist in this browser. Please try again.');
      return false;
    }
  };
  const renderWishlist = () => {
    const items = readWishlist();
    document.querySelectorAll('[data-wishlist-count]').forEach((count) => { count.textContent = items.length; count.hidden = items.length === 0; });
    document.querySelectorAll('[data-wishlist-product]').forEach((product) => {
      const saved = items.some((item) => item.handle === product.dataset.handle);
      const button = product.querySelector('[data-wishlist-toggle]');
      if (!button) return;
      button.setAttribute('aria-pressed', String(saved));
      button.classList.toggle('is-saved', saved);
      const icon = button.querySelector('[aria-hidden="true"]');
      if (icon && icon.tagName.toLowerCase() !== 'svg') icon.textContent = saved ? '♥' : '♡';
      const label = document.documentElement.lang === 'ar'
        ? (saved ? 'إزالة من المفضلة' : 'أضف إلى المفضلة')
        : (saved ? 'Remove from wishlist' : 'Add to wishlist');
      button.setAttribute('aria-label', `${label}${product.dataset.title ? ` — ${product.dataset.title}` : ''}`);
      const labelText = button.querySelector('[data-wishlist-label]');
      if (labelText) labelText.textContent = label;
    });

    document.dispatchEvent(new CustomEvent('sahrava:wishlist-change', { detail: { items } }));
    const grid = document.querySelector('[data-wishlist-grid]');
    const empty = document.querySelector('[data-wishlist-empty]');
    if (!grid) return;
    grid.replaceChildren();
    empty?.toggleAttribute('hidden', items.length > 0);
    const templates = [...document.querySelectorAll('template[data-wishlist-card-template]')];
    items.forEach((item) => {
      const template = templates.find((candidate) => candidate.dataset.handle === item.handle);
      if (template?.content.firstElementChild) {
        const card = template.content.firstElementChild.cloneNode(true);
        const toggle = card.querySelector('[data-wishlist-toggle]');
        toggle?.setAttribute('aria-pressed', 'true');
        toggle?.classList.add('is-saved');
        const icon = toggle?.querySelector('[aria-hidden="true"]');
        if (icon && icon.tagName.toLowerCase() !== 'svg') icon.textContent = '♥';
        toggle?.setAttribute('aria-label', document.documentElement.lang === 'ar' ? `إزالة من المفضلة — ${item.title || item.handle}` : `Remove from wishlist — ${item.title || item.handle}`);
        grid.append(card);
        return;
      }
      const article = document.createElement('article');
      article.className = 'wishlist-card';
      const link = document.createElement('a');
      link.href = item.url?.startsWith('/') ? item.url : sahrava.root;
      link.className = 'wishlist-card-media';
      const image = document.createElement('img');
      const currentImage = item.handle === grid.dataset.currentProductHandle ? grid.dataset.currentProductImage : '';
      const imageSource = currentImage || item.image;
      if (imageSource?.startsWith('/') || imageSource?.startsWith('https://')) image.src = imageSource;
      if (currentImage) link.classList.add('wishlist-card-media-current');
      image.alt = item.title || '';
      image.loading = 'lazy';
      link.append(image);
      const content = document.createElement('div');
      const title = document.createElement('h2');
      const titleLink = document.createElement('a');
      titleLink.href = link.href;
      titleLink.textContent = item.title || item.handle;
      title.append(titleLink);
      const price = document.createElement('p');
      price.textContent = item.price || '';
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.dataset.wishlistRemove = item.handle;
      remove.textContent = document.documentElement.lang === 'ar' ? 'إزالة' : 'Remove';
      content.append(title, price, remove);
      article.append(link, content);
      grid.append(article);
    });
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      const product = toggle.closest('[data-wishlist-product]');
      if (!product?.dataset.handle) return;
      const items = readWishlist();
      const index = items.findIndex((item) => item.handle === product.dataset.handle);
      if (index >= 0) items.splice(index, 1);
      else items.push({ handle: product.dataset.handle, title: product.dataset.title || '', url: product.dataset.url || '/', image: product.dataset.image || '', price: product.dataset.price || '' });
      if (!writeWishlist(items)) return;
      renderWishlist();
      sahrava.showToast(index >= 0 ? (document.documentElement.lang === 'ar' ? 'تمت الإزالة من المفضلة' : 'Removed from wishlist') : (document.documentElement.lang === 'ar' ? 'تم الحفظ في المفضلة' : 'Saved to wishlist'));
    }
    const remove = event.target.closest('[data-wishlist-remove]');
    if (remove) {
      if (!writeWishlist(readWishlist().filter((item) => item.handle !== remove.dataset.wishlistRemove))) return;
      renderWishlist();
    }
  });

  const heritagePage = document.querySelector('[data-heritage-page]');
  if (heritagePage) {
    const revealTargets = [...heritagePage.querySelectorAll('[data-scroll-reveal]')];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reducedMotion && 'IntersectionObserver' in window && revealTargets.length) {
      document.documentElement.classList.add('has-heritage-motion');
      const revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -10% 0px' });

      revealTargets.forEach((target) => revealObserver.observe(target));
      window.requestAnimationFrame(() => {
        revealTargets.filter((target) => target.closest('.heritage-hero')).forEach((target) => {
          target.classList.add('is-visible');
          revealObserver.unobserve(target);
        });
      });
    } else {
      revealTargets.forEach((target) => target.classList.add('is-visible'));
    }

    const chapterLinks = [...heritagePage.querySelectorAll('[data-heritage-link]')];
    const chapterSections = [...heritagePage.querySelectorAll('[data-heritage-chapter]')];
    const setActiveChapter = (id) => {
      chapterLinks.forEach((link) => {
        if (link.dataset.heritageLink === id) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    };
    chapterLinks.forEach((link) => link.addEventListener('click', () => setActiveChapter(link.dataset.heritageLink)));
    if ('IntersectionObserver' in window && chapterLinks.length && chapterSections.length) {
      const chapterObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActiveChapter(entry.target.id);
        });
      }, { threshold: 0, rootMargin: '-34% 0px -54% 0px' });
      chapterSections.forEach((chapter) => chapterObserver.observe(chapter));
    }
  }

  const faqPage = document.querySelector('[data-faq-page]');
  if (faqPage) {
    const search = faqPage.querySelector('[data-faq-search]');
    const items = [...faqPage.querySelectorAll('[data-faq-item]')];
    const groups = [...faqPage.querySelectorAll('.faq-group')];
    const empty = faqPage.querySelector('[data-faq-empty]');
    const normalize = (value) => value.toLocaleLowerCase(document.documentElement.lang || undefined).replace(/\s+/g, ' ').trim();
    search?.addEventListener('input', () => {
      const query = normalize(search.value);
      let visibleCount = 0;
      items.forEach((item) => {
        const matches = !query || normalize(item.textContent || '').includes(query);
        item.hidden = !matches;
        if (matches) visibleCount += 1;
      });
      groups.forEach((group) => {
        group.hidden = !group.querySelector('[data-faq-item]:not([hidden])');
      });
      if (empty) empty.hidden = visibleCount !== 0;
    });
  }

  const legalPolicy = document.querySelector('[data-legal-policy]');
  if (legalPolicy) {
    const richtext = legalPolicy.querySelector('[data-policy-richtext]');
    const toc = legalPolicy.querySelector('[data-policy-toc]');
    const list = toc?.querySelector('ol');
    richtext?.querySelectorAll('h2, h3, h4, p').forEach((element) => {
      if (!element.textContent.replace(/\u00a0/g, '').trim()) element.remove();
    });
    const headings = [...(richtext?.querySelectorAll('h2, h3') || [])].filter((heading) => heading.textContent.trim());
    if (list && headings.length) {
      headings.forEach((heading, index) => {
        const number = String(index + 1).padStart(2, '0');
        heading.id = heading.id || `policy-section-${index + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.dataset.number = number;
        link.textContent = heading.textContent.trim().replace(/^\s*\d+[.)،.]?\s*/, '');
        item.append(link);
        list.append(item);
      });
    } else {
      toc?.setAttribute('hidden', '');
    }
  }

  window.SahravaWishlist = { read: readWishlist, refresh: renderWishlist };
  window.addEventListener('storage', (event) => {
    if (event.key === wishlistKey || event.key === null) renderWishlist();
  });
  renderWishlist();
});
